import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "./../api.service";

@Injectable({
  providedIn: "root",
})
export class ApiPaymentService {
  constructor(private apiService: ApiService) {}

  getPaymentList(request: any): Observable<any[]> {
    return this.apiService.post("/api/getPaymentList", request);
  }

  getPaymentObjList(request: any): Observable<any[]> {
    return this.apiService.post("/api/paymentObjList", request);
  }

  saveCreaterPaymantRequest(request: any): Observable<any[]> {
    return this.apiService.post("/api/saveCreaterPaymantRequest", request);
  }

  savePayment(request: any): Observable<any[]> {
    return this.apiService.post("/api/savePayment", request);
  }
  getMasterFeeRateList(request: any): Observable<any[]> {
    return this.apiService.post("/api/getMasterFeeRateList", request);
  }

  getRelationshipList(request: any): Observable<any[]> {
    return this.apiService.post("/api/getRelationshipList", request);
  }

  getDetailPaymentRequest(request: any): Observable<any[]> {
    return this.apiService.post("/api/getDetailPaymentRequest", request);
  }

  updateStatusPayment(request: any): Observable<any[]> {
    return this.apiService.post("/api/updateStatusPayment", request);
  }

  getCompanyListForPayment(request: any): Observable<any[]> {
    return this.apiService.post("/api/getCompanyListForPayment", request);
  }

  pullPaymentFromCSC(request: any): Observable<any[]> {
    return this.apiService.post("/api/pullPaymentFromCSC", request);
  }

  dataReprintForPay(request: any): Observable<any[]> {
    return this.apiService.post("/api/dataReprintForPay", request);
  }

  getCompanyAddressReciept(request: any): Observable<any[]> {
    return this.apiService.post("/api/getCompanyAddressReciept", request);
  }

  checkIsSeftPrint(request: any): Observable<any[]> {
    return this.apiService.post("/api/checkIsSeftPrint", request);
  }

  exportBillPayment(request: any): Observable<any[]> {
    return this.apiService.post("/api/exportBillPayment", request);
  }

  exportBillPaymentUpdate(request: any): Observable<any[]> {
    return this.apiService.post("/api/exportBillPaymentUpdate", request);
  }

  exportPDFReqPayment(request: any): Observable<any[]> {
    return this.apiService.post("/api/exportPDFReqPaymentNew", request);
  }
  getPaymentDetailByPackId(request: any): Observable<any[]> {
    return this.apiService.post("/api/paymentListGetByPackId", request);
  }

  paymentGetEmailETax(request: any): Observable<any[]> {
    return this.apiService.post("/api/paymentGetEmailETax", request);
  }
  getStatusPaymentList(): Observable<any[]> {
    return this.apiService.get("/api/getStatusPaymentList");
  }
  reportPayment(request: any): Observable<any[]> {
    return this.apiService.post("/api/reportPayment", request);
  }
  reportApporvedCoCf(request: any): Observable<any[]> {
    return this.apiService.post("/api/reportApporvedCoCf", request);
  }
  paymentObjForFreerateList(request: any): Observable<any[]> {
    return this.apiService.post("/api/paymentObjForFreerateList", request);
  }  
}
